import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
/**
   * 下拉树组件
   * @module $ui/components/my-form/src/common/TreeSelect
   */
import { Input, Tree } from 'element-ui';
import BasePicker from './BasePicker';
import TagInput from './TagInput';
import { create as createTree } from '@/utils/tree';
import { isEqual } from '@/utils/util';

/**
   * 属性参数
   * @member props
   * @property {string|number|array} [value] 值，多选为数组，支持双向绑定
   * @property {array} [options] 选项数组 [{id, parentId, label, value}]
   * @property {Object} [keyMap] 字段映射 {id, parentId, label, value, disabled}
   * @property {boolean} [multiple] 开启多选
   * @property {string} [size] 尺寸，可选值：'medium', 'small', 'mini', ''
   * @property {boolean} [disabled]  禁用
   * @property {boolean} [readonly] 只读
   * @property {number} [minWidth=300] 弹出层的最小宽度
   * @property {number} [maxHeight] 弹出层的最大高度
   * @property {boolean|function} [filter] 筛选函数， false即不开启筛选功能
   * @property {*} [root=null] 树的根节点，parentId的值
   * @property {boolean} [collapseTags]  折叠标签，多选有效
   * @property {boolean} [closable] 允许关闭标签，多选有效
   * @property {object} [tree] el-tree的其他参数
   *
   */
export default {
  components: {
    ElInput: Input,
    TagInput: TagInput,
    Tree: Tree,
    BasePicker: BasePicker
  },
  props: {
    // 值
    value: [String, Number, Array],
    // 选项数据
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 字段映射
    keyMap: {
      type: Object,
      default: function _default() {
        return {
          id: 'id',
          parentId: 'parentId',
          label: 'label',
          disabled: 'disabled',
          value: 'value'
        };
      }
    },
    // 开启多选
    multiple: Boolean,
    placeholder: String,
    // 尺寸
    size: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['medium', 'small', 'mini', ''].includes(val);
      }
    },
    // 禁用
    disabled: Boolean,
    // 只读
    readonly: Boolean,
    // 筛选函数
    filter: {
      type: [Boolean, Function],
      default: true
    },
    // 树的根节点，parentId的值
    root: {
      type: [String, Number, Boolean],
      default: null
    },
    // 折叠标签，多选有效
    collapseTags: Boolean,
    // 允许关闭标签，多选有效
    closable: {
      type: Boolean,
      default: true
    },
    // 树其他参数
    tree: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 弹出层的最大高度
    maxHeight: {
      type: Number,
      default: 300
    }
  },
  data: function data() {
    return {
      checked: null,
      query: ''
    };
  },
  computed: {
    treeStyle: function treeStyle() {
      return {
        maxHeight: "".concat(this.maxHeight, "px")
      };
    },
    optionsTree: function optionsTree() {
      var _this$keyMap = this.keyMap,
        id = _this$keyMap.id,
        parentId = _this$keyMap.parentId;
      return createTree(this.options || [], this.root, id, parentId);
    },
    currentNodeKey: function currentNodeKey() {
      if (this.multiple) {
        return;
      }
      return this.checked ? this.checked[this.keyMap.value] : undefined;
    },
    defaultCheckedKeys: function defaultCheckedKeys() {
      if (!this.multiple) return;
      var value = this.keyMap.value;
      return this.checked ? this.checked.map(function (n) {
        return n[value];
      }) : [];
    },
    filterNodeMethod: function filterNodeMethod() {
      var label = this.keyMap.label;
      return typeof this.filter === 'function' ? this.filter : function (value, data) {
        if (!value) return true;
        return data[label].indexOf(value) !== -1;
      };
    },
    tags: function tags() {
      var label = this.keyMap.label;
      return (this.checked || []).map(function (n) {
        return n[label];
      });
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        var value = this.keyMap.value;
        if (isEqual(val, this.checked)) return;
        if (this.multiple) {
          var vals = val ? [].concat(val) : [];
          this.checked = this.options.filter(function (item) {
            return vals.includes(item[value]);
          });
        } else {
          this.checked = this.options.find(function (item) {
            return val === item[value];
          });
        }
      }
    },
    checked: function checked(val) {
      this.$emit('change', val);
    },
    query: function query(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(item, node) {
      var _this = this;
      if (this.multiple || item.disabled || this.readonly || this.disabled) return;
      this.checked = item;
      this.$emit('input', item[this.keyMap.value]);
      this.$nextTick(function () {
        _this.$refs.picker.visible = false;
      });
    },
    handleCheckChange: function handleCheckChange() {
      this.checked = this.$refs.tree.getCheckedNodes();
      var value = this.keyMap.value;
      this.$emit('input', this.checked.map(function (n) {
        return n[value];
      }));
    },
    handleRemove: function handleRemove(index) {
      if (this.checked) {
        this.checked.splice(index, 1);
        var value = this.keyMap.value;
        var keys = this.checked.map(function (n) {
          return n[value];
        });
        this.$refs.tree.setCheckedNodes(keys);
        this.$emit('input', keys);
        this.$refs.picker.visible = false;
      }
    }
  }
};